import styled from 'styled-components';

export const ContactsSelectorHeaderWrapper = styled.div`
    .mobile-name-search {
        padding: 0 2rem 1rem 2rem;
    }

    .styled-header-wrapper {
        .styled-header {
            margin: 0;
            position: relative;
            background: #fff;
            border-radius: 6px;
            border: 1px solid #f0f0f0;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            padding: 1em 2em;

            &.styled-header-top-align {
                align-items: flex-start;
            }

            @media (max-width: 480px) {
                padding: 0.5rem;
            }

            font-size: 0.9rem;

            /* @media (max-width: 480px) {
                border-radius: 0;
            } */

            @media only screen and (max-width: 960px) {
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
            }
            @media only screen and (max-width: 720px) {
                align-items: center;
            }

            .header-summary {
                border-right: 1px solid #e8e8e8;
                flex: auto 0 0;
                padding: 0 1em 0 0;

                @media only screen and (max-width: 960px) {
                    border-right: none;
                    padding: 0;
                }

                .header-summary-text {
                    font-size: 1em;
                    display: flex;
                    align-items: center;

                    em.counter {
                        font-size: 1.6em;
                        font-weight: bold;
                        font-style: normal;
                        padding-right: 0.5em;
                    }
                }
                small.hidden-models {
                    display: block;
                }
            }

            .header-filters {
                display: flex;
                flex-direction: row;
                flex: 1 0 0;
                padding: 0 1em 0 1em;
                margin-bottom: auto;

                @media only screen and (max-width: 960px) {
                    flex-direction: column;
                    padding: 0;
                    flex: none;
                    align-items: flex-start;
                }

                .header-filters-first-row,
                .header-filters-second-row {
                    .control {
                        padding-right: 1em;
                    }

                    @media only screen and (max-width: 640px) {
                        flex-direction: column;
                        align-items: flex-start;
                        padding: 0;
                    }
                }
            }

            .header-actions {
                display: flex;
                flex-direction: row;
                margin-bottom: auto;
                flex: auto 0 0;
                padding: 0 0 0 1em;
                gap: 2rem;

                @media only screen and (max-width: 960px) {
                    flex-direction: column;
                    padding: 0;
                    min-width: 0;
                }
            }

            div.control {
                padding: 0.5em 0;
                span.label {
                    font-size: 0.85em;
                    text-transform: uppercase;
                    padding: 0 0.5em 0 0;

                    &.on-right {
                        padding: 0 0 0 0.5em;
                    }
                }
            }
        }
    }
`;
